import { useRecentEmails } from '../lib/queries';
import { Icon } from './icons';
import { Spinner } from './ui';
import { formatDateTime } from '../lib/format';

/** Nome amigável do remetente: "Nome <email>" → Nome (ou o e-mail). */
function cleanFrom(from: string): string {
  const m = from.match(/^\s*"?([^"<]*?)"?\s*<([^>]+)>/);
  if (m) return (m[1]?.trim() || m[2]?.trim()) ?? from.trim();
  return from.trim();
}

function emailDate(date?: string): string {
  if (!date) return '';
  const d = new Date(date);
  return Number.isNaN(d.getTime()) ? '' : formatDateTime(d.toISOString());
}

/**
 * Últimos e-mails recebidos na caixa parts@ — cada um abre direto no Gmail.
 * Read-only (não marca como lido). Some se a caixa não estiver configurada.
 */
export function RecentEmails() {
  const { data, isLoading } = useRecentEmails();

  if (!isLoading && data && !data.configured) return null;
  const items = data?.items ?? [];

  return (
    <section>
      <h2 className="text-sm font-semibold uppercase tracking-wide text-muted mb-3 flex items-center gap-2">
        <Icon name="mail" className="h-4 w-4 text-accent" /> Últimos e-mails recebidos
      </h2>

      {isLoading ? (
        <div className="text-sm text-muted flex items-center gap-2">
          <Spinner className="h-4 w-4" /> Carregando a caixa…
        </div>
      ) : items.length === 0 ? (
        <p className="text-sm text-muted">Nenhum e-mail na caixa.</p>
      ) : (
        <ul className="card divide-y divide-border/60 p-0 overflow-hidden">
          {items.map((e, i) => (
            <li key={i}>
              <a
                href={e.gmailUrl}
                target="_blank"
                rel="noreferrer noopener"
                className="flex items-start gap-3 px-3 py-2.5 hover:bg-surface-2/60 transition-colors"
                title="Abrir no Gmail"
              >
                <Icon name="mail" className="h-4 w-4 text-muted mt-0.5 shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium truncate">{e.subject || '(sem assunto)'}</div>
                  <div className="text-xs text-muted truncate">
                    {cleanFrom(e.from)}
                    {emailDate(e.date) ? ` · ${emailDate(e.date)}` : ''}
                  </div>
                </div>
                <Icon name="link" className="h-3.5 w-3.5 text-muted mt-0.5 shrink-0" />
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
